import React, { useContext, useState } from "react";
import "./ICDashboard.scss";
import { FormattedMessage } from "react-intl";
import { Typography } from "core/typography/Typography";
import { Table } from "core/table/Table";
import Icon from "core/icon/Icon";
import Button from "core/buttons/button/Button";
import InfoContext from "pages/InfoContext";
import {
  consultantNameFormatter,
  headerLabels,
} from "utils/sharedDashboardHelper";
import { dataLoading, formatDate, getEntityIsAllowed } from "utils/helper";
import Pagination from "core/pagination/Pagination";
import { EXPORT_FILE_TYPE, LANG, QUERY_STATUS } from "constants/constants";
import { useGeneralContext } from "api/directory/general/GeneralProvider";


const ICDashboard = () => {
  const {
    getDashboardIC,
    icDashboard,
    getDashboardExportFile,
    userScope,
    lang,
    nationalitiesList,
    selectedDate,
    jobList,
    icStatus,
    loadExportStatus,
    signedByFilter,
    expandFilterIds,
    filtersResolvable,
  } = useContext(InfoContext);
  const { namesByFilters } = useGeneralContext() || {};

  const [currentPage, setCurrentPage] = useState(1);
  const getCurrentPageContent = (page) => {
    // Holding here rather than paging with an unresolved branch filter, which
    // would return a page from the unfiltered dataset.
    if (!filtersResolvable) {
      return;
    }
    setCurrentPage(page);
    getDashboardIC({
      page: page,
      date: selectedDate,
      signed_by: expandFilterIds(signedByFilter),
    });
  };
  const { total_pages, total_items, content } = icDashboard;

  const header = [
    headerLabels.card,
    headerLabels.doyoubuzz,
    headerLabels.ic_start,
    headerLabels.phone_number,
    headerLabels.mobility,
    headerLabels.salary,
    headerLabels.last_fee,
    headerLabels.nat,
    headerLabels.job,
    headerLabels.email,
  ];

  const formattedData = () => {
    return icDashboard?.content?.map((item) => {
      const nationality = nationalitiesList.find(
        (nat) => nat.id === item.worker_nationality
      );
      const workerLink = `/${userScope}/consultant/${item.worker_slug}`;
      const isWorkerAllowed = getEntityIsAllowed(item.worker_id, namesByFilters);
      return {
        card: dataLoading(
          isWorkerAllowed === false ? (
            <span>{item.worker_id}</span>
          ) : (
            <a href={workerLink} target="_blank" rel="noopener noreferrer">
              {item.worker_id}
            </a>
          ),
          icStatus
        ),
        dyb: dataLoading(
          consultantNameFormatter({
            firstName: item.worker_first_name,
            lastName: item.worker_last_name,
            dybId: item.worker_dyb_showcase_id,
          }),
          icStatus
        ),
        ic_start: dataLoading(
          formatDate(item.worker_ic_start_date, lang),
          icStatus
        ),
        phone_number: dataLoading(item.worker_phone_number, icStatus),
        mobility: dataLoading(item.worker_geos?.join(", ") || "-", icStatus),
        salary: dataLoading(
          `${item.worker_salary} ${item.worker_salary_currency || ""}`,
          icStatus
        ),
        last_fee: dataLoading(
          `${item.worker_last_tjm || "-"} ${
            item.worker_last_tjm_currency || ""
          }`,
          icStatus
        ),
        nat: dataLoading(
          lang === LANG.FR
            ? nationality?.nationality_fr
            : nationality?.nationality_eng,
          icStatus
        ),
        job: dataLoading(
          item?.worker_domain_id
            ? jobList?.map((job) => {
                if (job.id === item.worker_domain_id)
                  return lang === LANG.FR ? job.fr : job.en;
              })
            : "-",
          icStatus
        ),
        email: dataLoading(
          <a
            href={`mailto:${item.worker_email}`}
            style={{
              textDecoration: "none",
              color: "inherit",
            }}
          >
            @
          </a>,
          icStatus
        ),
      };
    });
  };

  return (
    <>
      <div className="dashboard-objectives-and-realized-wrapper">
        <div>
          <Typography
            className="title-3 violet text-uppercase"
            type="h2"
            label={
              <FormattedMessage
                id="intercontracts_dashboard"
                defaultMessage="LES INTERCONTRATS"
              />
            }
          />
          <div className="table-buttons-wrapper">
            {content?.length > 0 && (
              <div className="display-flex results">
                <Typography
                  className="title-3 violet text-uppercase"
                  type="h2"
                  label={
                    <>
                      <FormattedMessage
                        id="results"
                        defaultMessage="Résultats"
                      />
                      <span>: {total_items}</span>{" "}
                    </>
                  }
                />
              </div>
            )}
            <Button
              className="btn-outlined"
              size="medium"
              color="white"
              disabled={loadExportStatus === QUERY_STATUS.LOADING}
              onClick={() =>
                getDashboardExportFile({
                  userScope,
                  queryParams: { date: selectedDate },
                  lang,
                  exportFileType: EXPORT_FILE_TYPE.IC,
                })
              }
            >
              <Icon icon="sheet" color="green" height={20} marginRight={9} />
              <FormattedMessage
                id="export_excel"
                defaultMessage="Exporter en Excel"
              />
            </Button>
          </div>
        </div>
        <div className="section-table">
          <Table
            id={`missions-by-filters`}
            header={header}
            content={formattedData() || []}
            tableWidth={"100%"}
            toolsManagerMission={false}
            userScope={userScope}
            alternRowColor={true}
          />
          {total_items > 0 && (
            <div className="pagination">
              <Pagination
                total_pages={total_pages}
                getCurrentPageContent={getCurrentPageContent}
                page={currentPage}
              />
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default ICDashboard;
